import type { JSX } from "preact";
import type { Icon } from "react-bootstrap-icons";
import "./icon.css";

export type { Icon } from "react-bootstrap-icons";

export {
    PlusCircle as Add,
    PlusSquare as AddSquare,
    ArrowLeft as BackArrow,
    BarChartFill as BarChart,
    StopFill as Block,
    BodyText,
    XSquare as Cancel,
    CardChecklist,
    CheckLg as Check,
    CheckAll,
    Check2Square as Checked,
    Clock,
    ChevronDown as Collapse,
    Copy,
    XSquare as Declined,
    Download,
    PencilSquare as Edit,
    Envelope as Email,
    ChevronRight as Expand,
    Eye,
    FileEarmark as File,
    Funnel as Filter,
    Folder,
    QuestionCircle as Help,
    Link45deg as Link,
    ListColumns,
    Lock as Locked,
    BoxArrowInRight as Login,
    BoxArrowRight as Logout,
    ArrowsMove as Move,
    SkipForwardFill as Next,
    PieChartFill as PieChart,
    SkipBackwardFill as Previous,
    ArrowClockwise as Refresh,
    Trash3 as Remove,
    Floppy as Save,
    Search,
    Table,
    HandThumbsDown as ThumbsDown,
    HandThumbsUp as ThumbsUp,
    Square as Unchecked,
    ArrowCounterclockwise as Undo,
    ArrowUpCircle as Upgrade,
    Upload,
    ExclamationDiamond as Warning,
} from "react-bootstrap-icons";

export function MeanChart(props: Parameters<Icon>[0]): ReturnType<Icon> {
    return (
        <svg
            fill="#000000"
            width="64px"
            height="64px"
            viewBox="2 2 30 30"
            id="icon"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M23,24c-3.5991,0-5.0293-4.1758-6.4126-8.2139C15.2764,11.9583,13.92,8,11,8a3.44,3.44,0,0,0-3.0532,2.3215L6.0513,9.6838C6.1016,9.5334,7.3218,6,11,6c4.3491,0,6.0122,4.8547,7.48,9.1379C19.6885,18.6667,20.83,22,23,22a3.44,3.44,0,0,0,3.0532-2.3215l1.8955.6377C27.8984,20.4666,26.6782,24,23,24Z" />
            <path d="M4,28V17H6V15H4V2H2V28a2,2,0,0,0,2,2H30V28Z" />
            <rect x={8} y={15} width={2} height={2} />
            <rect x={12} y={15} width={2} height={2} />
            <rect x={16} y={15} width={2} height={2} />
            <rect x={20} y={15} width={2} height={2} />
            <rect x={24} y={15} width={2} height={2} />
            <rect x={28} y={15} width={2} height={2} />
        </svg>
    );
}

export function Placeholder(): JSX.Element {
    return <span className="icon-placeholder" />;
}
